import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useState, useRef } from "react";
import PropTypes from "prop-types";
import { Flex, SearchInput, Link } from "@base-ui";
import { Options, Option } from "./searchableSelectLink.styles";
import { useOpen, useClickOutside, useCustomEffect } from "hooks";
import handleKeyDown from "./handleKeyDown";
import { extendedSystemStylesProps } from "@mixins";
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var styledSystemKeys = ["color", "space", "layout", "flexbox"];
var SearchableSelectLink = function SearchableSelectLink(props) {
  var id = props.id,
    label = props.label,
    options = props.options,
    hideLabel = props.hideLabel,
    inverted = props.inverted,
    searchString = props.searchString,
    search = props.search,
    placeholder = props.placeholder,
    style = props.style,
    autoFocus = props.autoFocus,
    className = props.className,
    disabled = props.disabled,
    disabledLabel = props.disabledLabel;
  var _useState = useState(-1),
    _useState2 = _slicedToArray(_useState, 2),
    activeFocus = _useState2[0],
    setActiveFocus = _useState2[1]; //idx
  var _useOpen = useOpen(false),
    open = _useOpen.open,
    setOpen = _useOpen.setOpen;
  var containerRef = useRef();
  var searchRef = useRef();
  handleKeyDown(id, containerRef, searchRef, open, setOpen, activeFocus, setActiveFocus, searchString, search, options);
  useClickOutside(containerRef, function () {
    setOpen(false);
    setActiveFocus(-1);
  }, open);
  useCustomEffect(function () {
    if (searchString.length < 3 && open) setOpen(false);else if (searchString.length > 2 && !open) setOpen(true);
  }, [searchString]);
  var optionsMarkup = options.map(function (option, idx) {
    return /*#__PURE__*/_jsx(Option, {
      id: "".concat(id, "-option-").concat(idx),
      role: "option",
      children: /*#__PURE__*/_jsx(Link, {
        id: "".concat(id, "-link-").concat(idx),
        label: option.label,
        tabIndex: -1,
        to: option.to,
        onClick: function onClick() {
          return setOpen(false);
        },
        children: option.label
      })
    }, option.id);
  });
  return /*#__PURE__*/_jsxs(Flex.Column, _objectSpread(_objectSpread({
    ref: containerRef,
    className: className,
    style: _objectSpread({
      position: "relative"
    }, style)
  }, extendedSystemStylesProps(styledSystemKeys, props)), {}, {
    children: [/*#__PURE__*/_jsx(SearchInput, {
      searchRef: searchRef,
      id: "".concat(id, "-input"),
      ariaHasPopup: "listbox",
      ariaExpanded: open,
      ariaControls: "".concat(id, "-listbox"),
      ariaAutocomplete: "list",
      value: searchString,
      label: !disabled ? label : disabledLabel,
      search: search,
      inverted: inverted,
      placeholder: placeholder,
      disabled: disabled,
      autoFocus: autoFocus,
      onFocus: function onFocus() {
        return options.length > 0 && setOpen(true);
      },
      title: disabled ? disabledLabel : undefined,
      hideLabel: hideLabel,
      icon: "search"
    }), /*#__PURE__*/_jsx(Options, {
      id: "".concat(id, "-listbox"),
      "aria-labelledby": "".concat(id, "-input-label"),
      role: "listbox",
      open: open,
      children: optionsMarkup
    })]
  }));
};
SearchableSelectLink.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired,
  searchString: PropTypes.string.isRequired,
  search: PropTypes.func.isRequired,
  hideLabel: PropTypes.bool,
  placeholder: PropTypes.string,
  inverted: PropTypes.bool,
  style: PropTypes.object,
  className: PropTypes.string,
  disabled: PropTypes.bool,
  disabledLabel: PropTypes.string
};
export default SearchableSelectLink;